module.exports = __webpack_public_path__ + "static/media/cookiless.8b8e8c68.svg";